import React from 'react';
import { Linkedin, Twitter, Mail, GraduationCap } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Mail, href: 'mailto:dr.ayaz.afsar@gmail.com', label: 'Email' },
    { icon: GraduationCap, href: '#', label: 'ResearchGate' },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-blue-900 via-blue-800 to-cyan-900 text-white py-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          {/* Brand */}
          <div>
            <h3 className="font-bold text-xl mb-2">Dr. Ayaz Afsar</h3>
            <p className="text-blue-100 text-xs leading-relaxed">
              Professor of English, Applied Linguist, and Academic Leader dedicated to advancing scholarship and education.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-base mb-3">Quick Links</h4>
            <ul className="space-y-1.5">
              {['About', 'Skills', 'Experience', 'Projects', 'Publications', 'Conferences', 'Contact'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => {
                      const element = document.getElementById(item.toLowerCase());
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-blue-100 hover:text-cyan-300 transition-colors text-xs"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="font-semibold text-base mb-3">Connect</h4>
            <div className="flex space-x-3">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    aria-label={social.label}
                    className="w-9 h-9 bg-blue-800 hover:bg-cyan-600 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                  >
                    <Icon size={16} />
                  </a>
                );
              })}
            </div>
            <p className="text-blue-100 text-xs mt-4">
              dr.ayaz.afsar@gmail.com
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-blue-700 flex flex-col md:flex-row justify-between items-center">
          <p className="text-blue-100 text-xs">
            © {currentYear} Dr. Ayaz Afsar. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="mt-3 md:mt-0 text-xs text-blue-100 hover:text-cyan-300 transition-colors"
          >
            Back to Top ↑
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
